import { Injectable } from '@angular/core';

import { AppConfig } from '../app.config';
import { throwError } from 'rxjs';
import { filter, map, catchError } from 'rxjs/operators';
import { HelpersService } from './helpers.service';
import { HttpClient } from '@angular/common/http';
import { ErrorHandlerService } from './errorhandler.service';// Add this for error feedback
 
@Injectable({
  providedIn: 'root',
})
export class ProcurementService {
  private apiURL: string = '';

  constructor(
    private http: HttpClient,
    private appConfig: AppConfig,
    private helpersService: HelpersService, 
    private errorHandler: ErrorHandlerService,// Add this for error feedback
  ) {
    this.apiURL = this.appConfig.getEnvironment();
  }

  getAutoComplete(data: any) {
    let requestOptions = this.helpersService.getAuthenticatedRequestOptions();
    return this.http
      .post(
        this.apiURL + '/api/Partner/searchProductsByLocation',
        data,
        requestOptions,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res);
        }),
      );
  }

  searchPartnersForProduct(data: any) {
    let requestOptions = this.helpersService.getAuthenticatedRequestOptions();
    return this.http
      .post(
        this.apiURL + '/api/Partner/searchPartnersForProduct',
        data,
        requestOptions,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res);
        }),
      );
  }
}
